import React from 'react'
import moment from 'moment'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import './Trips.css'
import Card from '../core/Card'
import SideNav from '../layout/SideNav'
import { Icon, BackIcon, BriefcaseIcon, CarIcon, DotIcon } from '../core/icons'
import { Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown } from 'antd';
import { connect } from 'react-redux'
import { batchClassify, toggleTrip, loadMore, getTrips, updateRange, selectFilter, clearFilters, selectPlaceFilter, untoggleAllTrips } from './actions'
import Summary from './Summary'
import { withPreviousDate } from './reducer'
import TripLine from './TripLine'
import All from './All'
import Update from './Update'
import Create from './Create'
import TitleBar from './TitleBar'


const Trips = () =>
  <div className="Trips">
    <TitleBar/>
    <Summary/>
    <All/>
  </div>

export default ()=>

    <Switch>
      <Route path={'/trips/new'} component={Create}/>
      <Route path={'/trips/:tripId'} component={Update}/>
      <Route path={'/trips'} component={Trips}/>
    </Switch>



// WEBPACK FOOTER //
// ./src/trips/Trips.js